import {
  JOIN_GAME_REQUEST,
  JOIN_GAME_REQUEST_SUCCESS,
  JOIN_GAME_REQUEST_ERROR,
  GAME_EXIT_REQUEST,
} from "../actionTypes/type";

export const joinRequest = (paramsData, onSuccess, onError) => {
  return {
    type: JOIN_GAME_REQUEST,
    params: paramsData,
    onSuccess,
    onError
  };
};

export const actionSuccess = (result) => {
  return {
    type: JOIN_GAME_REQUEST_SUCCESS,
    payload: result,
    error: null,
  };
};

export const actionError = (error) => {
  return {
    type: JOIN_GAME_REQUEST_ERROR,
    error: error,
    payload: null,
  };
};

export function exitGame() {
  return {
    type: GAME_EXIT_REQUEST,
    payload: {},
  };
}
